import { asyncPipeSpread } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import swapListSerialAndName from 'app/_shared/action/partial/swapListSerialAndName'

export default module => component => async (...args) => asyncPipeSpread(
  swapListSerialAndName(module),
)(find(component), ...args)
